import axios from 'axios';
import resolve  from '../resolver.js';
import checkJwt from '../../Global/jwtChecker';
import logout from '../../Global/logout';

export default async function GetCountries(
    data
) {

    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    let query = "?page=" + data.activePage +
        "&size=" + data.pageSize +
        "&searchFor=" + data.search.searchFor +
        "&sortBy=" + data.sortBy.id +
        "&sortDirection=" + data.sortDirection

    if(data.activeOnly === "Active"){
        query += "&onlyActive=true"
    }
    else if(data.activeOnly === "Inactive"){
        query += "&onlyActive=false"
    }

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/country/list' + query, {
            method: 'get',
            headers: { 'Authorization' : unHashedJwt}           
        }).then(res => res.data)
        .catch(error => error.response.data.status === 401 ? logout() : error.response )
    );
}